import { Dropdown, TDropdownElementProps } from '../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { MobilityTransactionTypeData } from '../../../../types/mobility/IMobilityGroup';

export const MobilityAdditionButton = ({
  onClick,
  showMenu,
  featureEnabled,
  transactionTypes,
}: {
  onClick: () => void;
  showMenu: boolean;
  featureEnabled: boolean;
  transactionTypes: MobilityTransactionTypeData[];
}) => {
  let additionActionItems: TDropdownElementProps[] = Object.values(transactionTypes).map((transactionType) => ({
    label: transactionType.label,
    onClick: () => {},
  }));

  if (!featureEnabled) {
    return <></>;
  }

  return (
    <>
      <button onClick={onClick} className="bg-green-50 h-8">
        <FontAwesomeIcon icon={faPlus} className="pr-2" />
        Add
      </button>
      {
        <Dropdown
          show={showMenu}
          items={additionActionItems}
          zIndex={999}
          position={{
            anchor: 'bottom-left',
            x: 0,
            y: 0,
          }}
        />
      }
    </>
  );
};
